import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { Draw } from 'ol/interaction';
import { ModalControlService } from 'src/app/services/modal-control.service';
import olMap from 'ol/Map';
import { MapService } from 'src/app/services/map.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { UtilsService } from 'src/app/services/utils.service';
import { TerrainAltitudeCutDTO } from 'src/app/models/TerrainAltitudeCutModel';
import { CurvePointDTO } from 'src/app/models/curvePointDTO';
import * as olProj from 'ol/proj';
import { CalculationsService } from 'src/app/services/calculations.service';
import { toLonLat } from 'ol/proj';
import { CalculationSettingsModel, RNAVModel } from 'src/app/models/configuration';
import { TabsService } from 'src/app/services/tabsService';


@Component({
  selector: 'app-terrain-altitude-cut',
  templateUrl: './terrain-altitude-cut.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class TerrainAltitudeCutComponent implements OnInit {

  decimate: boolean = false;

  draw: Draw;
  map: olMap;

  @Input() feature: Feature<any>;

  model: TerrainAltitudeCutDTO;
  readonly forbiddenSubstringName = TabsService.SEPARATOR;
  constructor(
    private modalService: ModalControlService,
    private mapService: MapService,
    private configurationController: ConfigurationService,
    private utilsService: UtilsService,
    private calculationService: CalculationsService,
    public bsModalRef: BsModalRef,
  ) {
  }

  ngOnInit(): void {
    this.map = this.mapService.getMap('map');

    this.model = new TerrainAltitudeCutDTO();

    // Set initial altitude
    this.model.altitudeFT = this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeFT;
    this.model.altitudeM = this.configurationController.currentConfiguration.defaultAltitudes.singleLevelAltitudeM;
  }

  changeDecimate(): void {
    this.decimate = !this.decimate;
  }

  changeAltitude(value: number, type: string) {
    switch (type) {
      case "FT":
        this.model.altitudeM = this.utilsService.feetToMeters(value);
        break;

      case "M":
        this.model.altitudeFT = this.utilsService.metersToFeet(value);
        break;
    }
  }

  calculate() {

    // Transfrom coordinates
    if (this.feature != null) {

      let coordinates = this.feature.getGeometry().getCoordinates()[0];

      coordinates.forEach(coordinate => {
        let coord: CurvePointDTO = CurvePointDTO.mapLonLatCoordinatesToService(olProj.toLonLat(coordinate, this.map.getView().getProjection()));
        if (this.model.coordinates.findIndex(x => x.latitude == coord.latitude && x.longitude === coord.longitude) == -1) {
          this.model.coordinates.push(coord);
        }
      });
    }

    // Set configuration settings
    this.model.calculationSettings = CalculationSettingsModel.mapToCalculation(this.configurationController.currentConfiguration);
    this.model.rnav = RNAVModel.mapToCalculation(this.configurationController.currentConfiguration.rnav);

    this.calculationService.calculateTerrainAltitudeCut(this.model);
    this.bsModalRef.hide();
  }

  cancelTerrainAltitudeCut(): void {
    this.bsModalRef.hide();
  }

}
